import { render } from "./ModalUpdateAccessType.vue?vue&type=template&id=45d0c541"
import script from "./ModalUpdateAccessType.vue?vue&type=script&lang=js"
export * from "./ModalUpdateAccessType.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__